import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AuthProvider } from './AuthContext';
import Dashboard from './pages/Dashboard';
import LogViewer from './pages/LogViewer';
import Charts from './pages/Charts';
import Top from './pages/Top';
import AppInsights from './pages/AppInsights';
import './App.css';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  const handleLogin = () => {
    instance.loginRedirect({
      scopes: ['openid', 'profile', 'email']
    });
  };

  // Show loading or login screen if not authenticated
  if (!isAuthenticated) {
    return (
      <div className="App">
        <div className="login-container">
          <div className="login-box">
                    <img src="/smlogo_colour.png" alt="SM Logo" className="login-logo" />
            <h1>Thesis SM Log Viewer</h1>
            <p>Please sign in with your organizational account to continue.</p>
            <button onClick={handleLogin} className="login-button">
              Sign In with Microsoft
            </button>
          </div>
        </div>
      </div>
    );
  }

  const userDisplayName = accounts[0]?.name || accounts[0]?.username || 'User';

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <nav className="navbar">
            <div className="nav-container">
              <div className="nav-brand">
                <Link to="/dashboard" className="brand-link">
                  <img src="/smlogo.png" alt="SM Logo" className="brand-logo" />
                  <h2>Thesis SM Log Viewer</h2>
                </Link>
              </div>
              <ul className="nav-menu">
                <li className="nav-item">
                  <Link to="/dashboard" className="nav-link">Dashboard</Link>
                </li>
                <li className="nav-item">
                  <Link to="/logs" className="nav-link">Log Viewer</Link>
                </li>
                <li className="nav-item">
                  <Link to="/appinsights" className="nav-link">App Insights</Link>
                </li>
                <li className="nav-item">
                  <Link to="/charts" className="nav-link">Charts</Link>
                </li>
                <li className="nav-item">
                  <Link to="/top" className="nav-link">Top</Link>
                </li>
                <li className="nav-item user-menu">
                  <span className="user-name">{userDisplayName}</span>
                  <button onClick={handleLogout} className="nav-link logout-button">
                    Sign Out
                  </button>
                </li>
              </ul>
            </div>
          </nav>

          <main className="main-content">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/logs" element={<LogViewer />} />
              <Route path="/charts" element={<Charts />} />
              <Route path="/top" element={<Top />} />
              <Route path="/appinsights" element={<AppInsights />} />
            </Routes>
          </main>

        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
